module.exports = __webpack_public_path__ + "static/Image_WOW_360-f03a40b80febd5543af9a8ce0ee4a4d5.png";